



















































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import moment from 'moment'
import FinanceiroStore from '@/components/RemuneracaoMedica/financeiro/Store/FinanceiroStore'
import { get } from 'lodash'

@Component
export default class ComponentErrosValidacao extends Vue {
  get modalErrosCarga() { return this.getFinanceiroStore.modal.errosCarga }
  set modalErrosCarga(value: boolean) { this.getFinanceiroStore.setModal({ name: 'errosCarga', value }) }

  get validacaoCargaErrosHeader() { return this.getFinanceiroStore.validacaoCargaErrosHeader }

  get validacaoErros() { return this.getFinanceiroStore.itensRecebimentoErros }

  get getPagina() {
    return this.getFinanceiroStore.pagina
  }

  set getPagina(value: number) {
    this.getFinanceiroStore.setPagina(value)
  }

   async getResults(pagina: any) {
    this.getPagina = pagina
    await this.getFinanceiroStore.getItemsRecebimentoErros(pagina.recebimentoId)
  }

  get pagination() {
    return this.getFinanceiroStore.pagination
  }

  formatMessage(message: string){
    return JSON.parse(message).message;
  }

  formatDateTimeUtil(date: string) {
    if (['', null, undefined].includes(date)) return 'Não informado'
    return moment(date).format('DD/MM/YYYY HH:mm')
  }

  get getFinanceiroStore() {
    return getModule(FinanceiroStore, this.$store)
  }

  get errosLength() {
    return Math.ceil(this.pagination.totalItems / this.pagination.rowsPerPage)
  }

  closeModal(){
    this.modalErrosCarga = false;
    this.getFinanceiroStore.setModal({ name: 'errosCarga', value: false })
    this.getPagina = 1;
  }
}
